import { configureStore } from '@reduxjs/toolkit';
import permissionsReducer from '../redux/role/permissionsSlice';
import roleReducer from '../redux/role/roleSlice';

const store = configureStore({
  reducer: {
    permissions: permissionsReducer,
    roles: roleReducer, // Include the roles reducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
